<script setup lang="ts">
/**
 * The app's one routed view (job #254). The player is kept mounted while the
 * learner steps off it to a learner page (the Brain, the Library and the
 * rest of the bottom-nav pages) and comes back, so Back lands on the course
 * already loaded: no bundle read, no script rebuild, no "Pulling your Dutch
 * together...". Anywhere else (schools, admin, sign-up doors) the kept
 * player is let go exactly as before. Rule: platform/playerKeepAlive.ts.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { wordViewKey, pinViewKey } from '@/games/wordCount/languageRoute'
import { playerKeepAliveInclude } from '@/platform/playerKeepAlive'

const route = useRoute()
const include = computed(() => playerKeepAliveInclude(route))
</script>

<template>
  <router-view v-slot="{ Component, route: viewRoute }">
    <KeepAlive :include="include">
      <component :is="Component" :key="wordViewKey(viewRoute) ?? pinViewKey(viewRoute)" />
    </KeepAlive>
  </router-view>
</template>
